import React from 'react';
import PropTypes from 'prop-types';

const NumberTwo = ({ fill, className = '' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="10.22"
    height="14.44"
    viewBox="0 0 10.22 14.44"
    className={className}
  >
    <path
      d="M-5.15-1.88C-5.15-.54-4.93,0-3.69,0h7.4c.96,0,1.36-.4,1.36-1.36V-3.52H2.71v.86a.4.4,0,0,1-.44.44H-1.89c-.38,0-.54-.1-.54-.36,0-2.58,6.86-2.86,6.86-7.66,0-2.64-2.12-4.2-4.6-4.2-1.84,0-4.32.86-4.32,2.74v1.4h2.36v-.62c0-.54.74-1.12,1.86-1.12A1.85,1.85,0,0,1,1.79-10.2C1.79-6.74-5.15-7.02-5.15-1.88Z"
      transform="translate(5.15 14.44)"
      fill={fill}
    />
  </svg>
);

NumberTwo.propTypes = {
  fill: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default NumberTwo;
